import React from "react";
import { AlertTriangle, ExternalLink } from "lucide-react";
import { formatAmount } from "../lib/enforcement";

// A real regulator action matched to the visitor's top gap, shown as a bold,
// high-contrast risk example. Facts and the source link come from the dataset.
export const RiskExample = ({ case: c }) => {
  if (!c) return null;
  const amount = formatAmount(c);
  const meta = [c.regulator, c.country].filter(Boolean).join(", ") + (c.year ? ` \u00b7 ${c.year}` : "");
  return (
    <div
      className="mt-6 rounded-2xl p-6 lg:p-7 shadow-lg"
      style={{ background: "#364F6B" }}
      data-testid="risk-example"
    >
      <div className="flex items-center gap-2 mb-3">
        <span className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wide px-2.5 py-1 rounded-full" style={{ background: "#FC5185", color: "#FFFFFF" }}>
          <AlertTriangle size={13} strokeWidth={2.5} /> Real world risk
        </span>
        <span className="text-[12.5px] text-white/70">A regulator has acted on a similar gap</span>
      </div>
      <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
        <h3 className="text-xl font-bold text-white leading-tight" data-testid="risk-company">{c.company}</h3>
        <div className="shrink-0 text-right">
          <div className="text-[10px] font-bold uppercase tracking-wider text-white/50">Regulator enforcement</div>
          <div className="text-2xl font-bold" style={{ color: "#FF7DA1" }} data-testid="risk-amount">{amount}</div>
        </div>
      </div>
      <div className="text-[12.5px] text-white/60 mt-1" data-testid="risk-meta">{meta}</div>
      <p className="mt-3.5 text-[14px] text-white/85 leading-relaxed" data-testid="risk-summary">{c.summary}</p>
      {c.source_url && (
        <div className="mt-4 border-t pt-3.5" style={{ borderColor: "rgba(255,255,255,0.15)" }}>
          <a href={c.source_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-[13px] font-semibold text-white hover:text-aqua transition-colors" data-testid="risk-source">
            Read the decision{c.source_label ? `: ${c.source_label}` : ""} <ExternalLink size={13} />
          </a>
        </div>
      )}
    </div>
  );
};
